/* eslint-disable import/prefer-default-export */

const requiredValidation: any = (value: string) => {
	if (!value) return 'این فیلد اجباری است';
	return false;
};

export { requiredValidation };
